module.exports = "<div ng-repeat=\"paymentMethod in $ctrl.paymentMethods | filter:{ type: 'other' } track by $index\"> <md-radio-button ng-value=\"paymentMethod.value\" class=\"md-primary\"> <div layout layout-align=\"space-between center\"> <div class=\"edit-account-label\">{{paymentMethod.name}}</div> <img ng-src=\"{{paymentMethod.imageUrl}}\" ng-if=\"paymentMethod.imageUrl\" height=\"24px\"> </div> </md-radio-button> </div> ";


//////////////////
// WEBPACK FOOTER
// ./src/app/components/editAccountPayment/otherPaymentMethodsList/otherPaymentMethodsList.html
// module id = 906
// module chunks = 0